/**
 * @fileoverview
 * Corrige impressão Serial de listas (SimpleList): o gerador original faz
 * Serial.println(lista), o que não compila em Arduino.
 * Quando o valor for um bloco data_listcontents, gera labcodeListToString(lista).
 */

const LIST_TO_STRING_FN = [
    'String labcodeListToString(SimpleList<String> &list) {',
    '  String s = "[";',
    '  for (int i = 0; i < list.size(); i++) {',
    '    if (i > 0) s += ", ";',
    '    s += list.get(i);',
    '  }',
    '  s += "]";',
    '  return s;',
    '}'
].join('\n');

const ensureListToStringHelper = Arduino => {
    if (!Arduino.customFunctions_) return;
    if (!Arduino.customFunctions_.labcodeListToString) {
        Arduino.customFunctions_.labcodeListToString = LIST_TO_STRING_FN;
    }
};

/**
 * Sobrescreve geradores de serial print para aceitar listas (vetores).
 * @param {object} ScratchBlocks - Instância openblock-blocks / Blockly
 */
export const patchArduinoListPrint = ScratchBlocks => {
    const Arduino = ScratchBlocks && ScratchBlocks.Arduino;
    if (!Arduino || Arduino.__labcodeListPrintPatched) {
        return;
    }
    Arduino.__labcodeListPrintPatched = true;

    const variablesNameType = ScratchBlocks.Variables && ScratchBlocks.Variables.NAME_TYPE ?
        ScratchBlocks.Variables.NAME_TYPE :
        'VARIABLE';

    const getListName = block => {
        const target = block.getInputTargetBlock('VALUE');
        if (!target || target.type !== 'data_listcontents') {
            return null;
        }
        if (!Arduino.variableDB_) {
            return null;
        }
        return Arduino.variableDB_.getName(target.getFieldValue('LIST'), variablesNameType);
    };

    const printValue = (serialExpr, valueExpr, eol) => {
        if (eol === 'warp') {
            return `${serialExpr}.println(${valueExpr});\n`;
        }
        return `${serialExpr}.print(${valueExpr});\n`;
    };

    Arduino.arduino_serial_serialPrint = function (block) {
        const eol = block.getFieldValue('EOL') || 'warp';
        const listName = getListName(block);
        if (listName) {
            ensureListToStringHelper(Arduino);
            return printValue('Serial', `labcodeListToString(${listName})`, eol);
        }
        const value = Arduino.valueToCode(block, 'VALUE', Arduino.ORDER_UNARY_POSTFIX) || '';
        return printValue('Serial', value, eol);
    };

    Arduino.arduino_serial_multiSerialPrint = function (block) {
        let no = block.getFieldValue('NO') || '0';
        const eol = block.getFieldValue('EOL') || 'warp';
        if (no === '0') {
            no = '';
        }
        const serialExpr = `Serial${no}`;
        const listName = getListName(block);
        if (listName) {
            ensureListToStringHelper(Arduino);
            return printValue(serialExpr, `labcodeListToString(${listName})`, eol);
        }
        const value = Arduino.valueToCode(block, 'VALUE', Arduino.ORDER_UNARY_POSTFIX) || '';
        return printValue(serialExpr, value, eol);
    };
};

export default patchArduinoListPrint;
